import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { BloqueioAgendaRequest } from 'src/app/admihair/api/dto/bloqueio-agenda-request';
import { BloqueioAgendaResponse } from 'src/app/admihair/api/dto/bloqueio-agenda-response';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { BloqueioAgendaService } from 'src/app/admihair/service/bloqueio-agenda.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-bloqueio-inserir',
  templateUrl: './bloqueio-inserir.component.html',
  styleUrls: ['./bloqueio-inserir.component.scss']
})
export class BloqueioInserirComponent extends AdmihairBaseComponent {

  @Input() visible: boolean = false;
  @Input() dataBloqueio: any;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() salvar = new EventEmitter<boolean>();

  bloqueioAgenda: BloqueioAgendaRequest = {
    titulo: '',
    descricao: '',
  }
  @Input() selectProfissinaisBloqueio: SelectItem[] = [{ label: 'TODOS', value: null }];
  profissinalSelecionado?: Profissional;

  constructor(private bloqueioAgendaService: BloqueioAgendaService,
    erroService: ErroService,
    storageService: UtilStorageService
  ) {
    super(erroService, storageService)
  }

  salvarBloqueio() {
    this.bloqueioAgenda.dataBloqueio = this.dataBloqueio;
    this.bloqueioAgenda.profissionalId = this.profissinalSelecionado?.id;
    this.bloqueioAgendaService.salvar(this.bloqueioAgenda).subscribe({
      next: (data: BloqueioAgendaResponse) => {
        this.salvar.emit(true);
        this.fechar();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
        this.salvar.emit(false);

      }
    });
  }


  fechar() {
    this.visible = false;
    this.resetarEstado();
    this.visibleChange.emit(false);
  }

  resetarEstado() {
    this.bloqueioAgenda = {
      titulo: '',
      descricao: '',
    }
    this.profissinalSelecionado = undefined;
    this.messagesDialog = [];
  }

}
